import React from 'react';
import clsx from 'clsx';
import EmptyStateBellError from 'shared/assets/images/empty-state-bell-error.svg';
import EmptyStateBellSleeping from 'shared/assets/images/empty-state-bell-sleeping.svg';
import './style.less';

interface BellMessageProps {
  type: 'error' | 'success' | 'empty';
  withContainer?: boolean;
  title: string;
  text?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export const BellMessage: React.FC<BellMessageProps> = ({
  type,
  withContainer,
  title,
  text,
  action,
  className,
}) => {
  return (
    <div
      className={clsx(
        'BellMessage',
        withContainer && 'BellMessage__container',
        className,
      )}
    >
      {type === 'error' && <EmptyStateBellError className="BellMessage__icon" />}
      {type === 'empty' && <EmptyStateBellSleeping className="BellMessage__icon" />}
      <div className={clsx('BellMessage__title', text && 'BellMessage__title--dark')}>
        {title}
      </div>
      <div className="BellMessage__text">{text}</div>
      {action}
    </div>
  );
};
